/**
 * Kann dieser Browser die Ego-Ansicht darstellen? Bewusst ohne three-Import,
 * damit die Pruefung keine halbe Megabyte 3D-Bibliothek nachlaedt — die kommt
 * erst, wenn jemand die Ansicht tatsaechlich einschaltet.
 */

/** Das Ergebnis aendert sich zur Laufzeit nicht — einmal pruefen genuegt. */
let unterstuetzt: boolean | null = null;

export function hasWebGL2(): boolean {
  if (unterstuetzt !== null) return unterstuetzt;
  try {
    const gl = document.createElement('canvas').getContext('webgl2');
    // Eine Seite hat nur eine Handvoll WebGL-Kontexte frei; darueber reisst
    // der Browser den aeltesten ab — und das waere der Kontext der
    // Draufsicht. Der Pruefkontext wird nicht gebraucht, also sofort zurueck.
    gl?.getExtension('WEBGL_lose_context')?.loseContext();
    unterstuetzt = gl !== null;
  } catch {
    unterstuetzt = false;
  }
  return unterstuetzt;
}
